export const useCarsalesCapi = () => {
	const config = useRuntimeConfig()

	const domain = config.public.APP_URL
	const version = config.public.CAPI_VERSION
	const versionUrl = config.public.CAPI_VERSION_URL
	const licenseKey = config.public.CAPI_LICENSE_KEY

	const scriptUrl = `${domain}/afx_prid/${version}/auth/als/p${versionUrl}.js?lcsid=${licenseKey}`

	useHead({
		link: [
			{
				rel: 'preload',
				href: scriptUrl,
				as: 'script',
				tagPriority: 'high',
			},
		],
		script: [
			{
				innerHTML: 'var afx_start = Date.now();',
			},
			{
				src: scriptUrl,
				async: true,
				type: 'text/javascript',
			},
		],
	})
}
